import React from 'react';
import { useNavigate } from 'react-router-dom';

export const LocationsPage = () => {
  const navigate = useNavigate();

  const styles = {
    container: {
      backgroundColor: "#d7ffd9",
      color: "#1b5e20",
      minHeight: "100vh",
      padding: "30px",
      paddingTop: "100px",
    },
    heading: {
      marginTop: 0,
      marginBottom: "30px",
      fontSize: "2.25rem",
      color: "#1b5e20",
      fontWeight: "bold",
      textTransform: "uppercase",
    },
    aboutButtonsWrapper: {
      display: "flex",
      gap: "12px",
      marginBottom: "30px",
      flexWrap: "wrap",
    },
    aboutButton: {
      padding: "6px 14px",
      borderRadius: "8px",
      border: "2px solid #2e7d32",
      backgroundColor: "transparent",
      color: "#1b5e20",
      fontSize: "1.15rem",
      fontWeight: 600,
      cursor: "pointer",
      transition: "all 0.2s ease",
    },
    aboutButtonActive: {
      padding: "6px 14px",
      borderRadius: "8px",
      border: "2px solid #1b5e20",
      backgroundColor: "#2e7d32",
      color: "white",
      fontSize: "1.15rem",
      fontWeight: 600,
      cursor: "default",
    },
    card: {
      backgroundColor: "white",
      borderRadius: "12px",
      boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
      padding: "30px",
      marginTop: "10px",
    },
    sectionTitle: {
      fontSize: "2rem",
      fontWeight: "bold",
      color: "#1b5e20",
      marginBottom: "15px",
    },
    sectionText: {
      fontSize: "1.2rem",
      lineHeight: "1.6",
      color: "#2e7d32",
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Locations</h1>
      <div style={styles.aboutButtonsWrapper}>
        <button onClick={() => navigate('/meet-the-team')} style={styles.aboutButton}>Meet the Team</button>
        <button style={styles.aboutButtonActive} aria-current="page">Locations</button>
        <button onClick={() => navigate('/events')} style={styles.aboutButton}>Events</button>
      </div>
      <div style={styles.card}>
        <h2 style={styles.sectionTitle}>Our Locations</h2>
        <p style={styles.sectionText}>Location information coming soon.</p>
      </div>
    </div>
  );
};
